import LayoutV2 from 'components/common/LayoutV2';
import EmailVerification from 'components/verified/EmailVerification';

const Verified = () => {
  return (
    <LayoutV2 title="User verified" hideMenu noindex>
      <EmailVerification />
    </LayoutV2>
  );
};

export default Verified;
